module.exports = __webpack_public_path__ + "img/Flag_of_Lesotho.9112a56b.svg";